// eslint-disable-next-line no-unused-vars
import ChatRepository from '../../../domain/repositories/ChatRepository';

class DeleteMessageUseCase {
    /**
     * @param {ChatRepository} chatRepository
     */
    constructor(chatRepository) {
        this.chatRepository = chatRepository;
    }

    /**
     * Deletes a message.
     * @param {string} conversationId
     * @param {string} messageId
     * @returns {Promise<void>}
     */
    async execute(conversationId, messageId) {
        return this.chatRepository.deleteMessage(conversationId, messageId);
    }
}

export default DeleteMessageUseCase;
